export const getInsightsDashboardKey = (assistantId) => `looker_insights_filters_${assistantId}`;
export const getUrlWithFilters = (baseUrl, dashboardKey) => {
  try {
    const savedFilters = sessionStorage.getItem(dashboardKey);
    if (savedFilters && savedFilters !== "null" && savedFilters !== "undefined") {
      const filters = JSON.parse(savedFilters);
      const url = new URL(baseUrl);

      Object.entries(filters).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          url.searchParams.set(key, value);
        }
      });

      return url.toString();
    }
  } catch (error) {
    console.error("Error loading looker filters from sessionStorage:", error);
  }
  return baseUrl;
};

export const deleteInsightsDashboardKey = (assistantId) => {
  try {
    const dashboardKey = getInsightsDashboardKey(assistantId);
    sessionStorage.removeItem(dashboardKey);
  } catch (error) {
    console.error("Error deleting looker filters from sessionStorage:", error);
  }
};
